export default "__VITE_ASSET__B$HcRiAm__"